/// <amd-module name="Pipeline/Analytics/Common/LoadAnalyticsDataService" />
import { IAnalyticsDataService } from "Analytics/Shared/Common/Types";
import { getContextTypeFromUrl } from "Analytics/Shared/Utils/URLHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export async function getAnalyticsDataService(pageContext: IVssPageContext): Promise<IAnalyticsDataService> {
    const contextType = getContextTypeFromUrl(pageContext);
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    if (contextType === "build") {
        await contributionService.getContributionAsync("ms.vss-analyticsshared-web.analytics-build-service");
        return pageContext.getService<IAnalyticsDataService>("IBuildAnalyticsDataService");
    } else {
        await contributionService.getContributionAsync("ms.vss-test-analytics-web.release-helper");
        return pageContext.getService<IAnalyticsDataService>("IReleaseAnalyticsDataService");
    }
}
